<template>
  <div v-if="currentEmploye">
    <SharedCompetence
      :currentEmploye="currentEmploye"
      :competencableUuid="competencableUuid"
      :competencableType="competencableType"
      @onRefresh="refresh"
    />
  </div>
</template>

<script>
import SharedCompetence from '@/views/rh/shared/competence/List';
import URL_E from '@/http/rh/employe';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      competencableUuid: null,
      competencableType: null,
    };
  },
  computed: {
    ...mapGetters('employe', ['currentEmploye', 'edit']),
  },
  components: {
    SharedCompetence,
  },
  methods: {
    ...mapActions('employe', [
      'setCurrentEmploye',
      'setCivilites',
      'setSituationFamiliales',
      'setLienParentes',
    ]),
    refresh() {
      this.setCivilites([]);
      this.setSituationFamiliales([]);
      this.setLienParentes([]);
      this.setCurrentEmploye(null);

      window.axios
        .all([
          window.axios.get(URL_E.GET_REQUIREMENTS),
          window.axios.get(URL_E.EMPLOYE + '/' + this.$route.params.id, {
            params: {
              edit: this.edit,
            },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setCivilites(resp1.data.civilites);
            this.setSituationFamiliales(resp1.data.situation_familiales);
            this.setLienParentes(resp1.data.lien_parentes);
            this.setCurrentEmploye(resp2.data.employe);
          })
        )
        .catch();
    },
  },
};
</script>

<style scoped></style>
